module.exports = __webpack_public_path__ + "public/images/header/arrow.f7b6b56ccd7d82554b9044aba651e1cc.svg";